// Keeps the lease identification token out of the address bar (S4, contract section 8.1).
//
// The identification link in the customer's email is https://m.24rent.fi/profile?lease=<token>. The token is a
// bearer for lease requests, so it must not reach React Router, analytics, console logs or error reports. This module
// runs when it is imported - src/index.tsx imports it first - which is before the router, the Redux store's first
// render and Ga4Tracker exist, so their first location never contains the token.
//
// A valid token (22 characters of base64url) is kept in sessionStorage next to the visit guard; any other value is
// removed from the address and not stored. Every other query parameter and the hash are left exactly as they were.

import { LEASE_TOKEN_KEY, LEASE_TOKEN_PATTERN, LEASE_VISIT_KEY, splitLeaseParam } from './services/leaseMode';

export function captureLeaseLink(): void {
  try {
    const search = window.location.search;
    if (!search || search.length < 2) {
      return;
    }
    const { rest, lease } = splitLeaseParam(search.slice(1));
    if (lease.length === 0) {
      return;
    }

    if (lease.length === 1) {
      let value = lease[0];
      try {
        value = decodeURIComponent(value);
      } catch (e) {
        // keep the raw value; it will not match the pattern
      }
      if (LEASE_TOKEN_PATTERN.test(value)) {
        try {
          sessionStorage.setItem(LEASE_TOKEN_KEY, value);
          sessionStorage.setItem(LEASE_VISIT_KEY, 'unbound');
        } catch (e) {
          // storage is blocked: the visit cannot be kept, but the token must still leave the address below
        }
      }
    }

    const cleaned = rest.length > 0 ? '?' + rest.join('&') : '';
    window.history.replaceState(window.history.state, '', window.location.pathname + cleaned + window.location.hash);
  } catch (e) {
    // never let the link capture stop the app from starting
  }
}

captureLeaseLink();
